<template>
  <router-view />
</template>

<script>
export default {

    computed: {
    pageinfo() {
      return JSON.parse(localStorage.getItem("pageinfo"));
    },
  },
  mounted() {
    if(this.pageinfo){
      const contact = JSON.parse(this.pageinfo.contact);
      let companyname  = "";
      if (contact.latinname) {
        companyname = contact.latinname;
      } else {
        companyname = contact.nativename;
      }
      document.title=companyname;
      const favicon = document.getElementById("favicon");
      let filepath = this.$store.state.apiurl;
      let icon = filepath + "/resources/filelibrary/" + this.pageinfo.logo;
      favicon.href = icon ; //"https://www.google.com/favicon.ico";
    }
   

    const customerinfo = localStorage.getItem('customerinfo')
    if(customerinfo==null || customerinfo==''){
      this.$store.state.authentcation = false;
    }
    else{
      this.$store.state.authentcation = true;
    }


    let that = this;
    window.$(window).on("load", function () {
      that.$router.replace({ path: "/" });
    });
  },
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
